angular.module('bb.users').directive('bbUserSelect', () => {
  return {
    restrict: 'E',
    scope: {
      userId: '=',
      canSelectAll: '=?',
    },
    controller: UserSelectController,
    bindToController: true,
    controllerAs: 'vm',
    template:
      "<bb-user-multi-select user-ids='vm._userIds' max-users='1' can-select-all='vm.canSelectAll'></bb-user-multi-select>",
  };
});

UserSelectController.$inject = ['$scope'];
function UserSelectController($scope) {
  const vm = this;
  $scope.$watch('vm.userId', function (newValue, oldValue) {
    if (newValue === oldValue) return;
    vm._userIds = [newValue];
  });

  this.$onInit = function () {
    vm._userIds = vm.userId ? [vm.userId] : [];
  };
  $scope.$watch(
    'vm._userIds',
    function (newValue) {
      if (newValue && newValue.length) {
        vm.userId = newValue[0];
      } else {
        vm.userId = '';
      }
    },
    true,
  );
}

export {};
